<template>
    <div class="container-card">
        <div class="container-card-group">
            <div class="beta">Beta</div>
            <header-integration-erp
                title="Integrações"
                subtitle="Essas são as integrações que já foram configuradas na sua instância."
            />
            <div class="container-card-erp">
                <div class="header">
                    <div class="erp">
                        <div v-for="(erp, index) in integrationCards" :key="index">
                            <card-erp :data="erp">
                                <button
                                    v-for="(option, key) in cardMenuOptions"
                                    :key="key"
                                    @click="call(option.action, erp)">
                                    {{ option.label }}
                                </button>
                            </card-erp>
                        </div>
                        <div class="erp-plus-card">
                            <ui-button design="lg primary" @click="addIntegration">
                                <em class="fal fa-plus" />
                            </ui-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer">
                <span class="footer-contract-components">Componentes contratados:</span>
                <div v-for="(component, index) in components" :key="index" class="footer-component">
                    <div v-if="component.active" class="footer-component-active" />
                    <div v-else class="footer-component-inactive" />
                    <span>{{ component.label }}</span>
                </div>
            </div>

            <ui-modal-message
                name="delete-integration-erp"
                title="Deseja realmente excluir esta integração?"
                text="Cuidado, esta ação não poderá ser desfeita."
                service="erp"
                btn-type="danger"
                btn-text="Confirmar"
                icon="fal fa-trash-alt"
                color-circle="danger"
                icon-circle
            />
        </div>
    </div>
</template>

<script>
import { CardErp, HeaderIntegrationErp } from '@/components/ui-facilita/marketing/erp/menu-card-erp'
import { uiButton } from '@/components/ui/buttons'
import { uiModalMessage } from '@/components/ui/modal'
import { utilMixin} from '@/mixins'
import { mapActions, mapGetters } from 'vuex'

export default {
	components: {
		CardErp,
		uiButton,
		HeaderIntegrationErp,
		uiModalMessage,
	},
	mixins: [utilMixin],


	data() {
		return {
			cardMenuOptions: [
				{
					label: 'Configuração do ERP',
					action: 'configuration',
				},
				{
					label: 'Mapear campos para Propostas',
					action: 'proposal-fields',
				},
				{
					label: 'Excluir',
					action: 'delete',
				},
			]
		}
	},

	computed: {
		...mapGetters('ERP', {
			integrations: 'getIntegrations',
			components: 'getComponents'
		}),
		/**
		 * Computed property que formata os dados das integrações para serem mostradas
		 * nos cards
		 */
		 integrationCards() {
			return Object.values(this.integrations).map((item) => {
				const card = {
					id: item.id,
					integration: item.type,
					title: item.business_name || 'Título não informado',
					subtitle: item.business_name
						? item.business_name
								.split(' ')
								.map((word, index) => {
									if (index === 0) word = word.slice(0, 4);

									return word.toLowerCase();
								})
								.join('-')
						: 'titu-não-informado',
					integrated_products: item.availabilities_count || 0,
					connection_params: {
						base_url: item.base_url,
						business_name: item.business_name,
						user: item.user,
						pass: item.pass,
						type: item.type,
						business_id: item.business_id,
						mode_corporate: item.data.mode_corporate,
						user_ad: item.data.user_ad
					}
				};

				/** Remove chaves  com valor null para que o payload fique menor */
				let params = {
					removeNulls: true,
					removeEmptyStrings: true,
					removeUndefined: true,
					removeFalse: true
				}

				let filteredCard = this.$mx_removeInvalidKeys(card, params)
				
				return filteredCard
			});
		}

	},

	created() {
		this.$root.$on('modal-msg-delete-integration-erp-response', (payload) => {
			this.removeIntegration(payload.data)
		})
	},

	beforeDestroy() {
		this.$root.$off('modal-msg-delete-integration-erp-response')
	},

	methods: {
		...mapActions('ERP', [
			'removeIntegration'
		]),
		/**
		 * Recebe uma action e os dados de uma integração e realiza a ação definida
		 * para tal action
		 */
		call(action, erp) {
			switch (action) {
				case 'configuration':
					this.$router.push({ name: 'marketing.integrations.erp.add', params: { id: erp.id } })
					break

				case 'proposal-fields':
					this.$router.push({
						name: 'marketing.integrations.erp.map_proposal',
						params: { id: erp.id},
					})
					break

				case 'delete':
					this.deleteIntegration(erp.id)
					break
			}
		},
		/**
		 * Requisita a remoção de uma integração
		 */
		deleteIntegration(id) {
			var config = {
				method: 'deleteV2',
				url: '',
				id: id,
				formdata: {},
				eventSuccess: 'modal-msg-delete-integration-erp-response',
			}
			this.$root.$emit('modal-msg-open-delete-integration-erp', config)
		},
		/**
		 * Redireciona para a tela de cadastro das integrações
		 */
		addIntegration() {
			this.$router.push({ name: 'marketing.integrations.erp.add' })
		}
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>